import React from "react";

const ComponentLibIcon = () => (
  <svg
    className="w-full h-full"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path fill="none" d="M0 0h24v24H0V0z"></path>
    <path d="M11.15 3.4L7.43 9.48c-.41.66.07 1.52.85 1.52h7.43c.78 0 1.26-.86.85-1.52L12.85 3.4a.993.993 0 00-1.7 0z"></path>
    <circle cx="17.5" cy="17.5" r="4.5"></circle>
    <path d="M4 21.5h6c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1z"></path>
  </svg>
);

export default ComponentLibIcon;
